/**
 * Utility for managing page titles across the application
 */

/**
 * Sets the page title with optional prefix/suffix
 * @param {string} title - The page title
 */
export const setPageTitle = (title) => {
  if (!title) {
    document.title = 'Unissn';
    return;
  }
  
  document.title = `${title} | Unissn`;
};

/**
 * Reset the page title to default
 */
export const resetPageTitle = () => {
  document.title = 'Unissn';
};
